// extracted by mini-css-extract-plugin
export default {"card":"w4-z"};